export default __webpack_public_path__ + "static/media/createTeamHC.e66f2675.svg";